import styled from 'styled-components';

import ContentHeaderStyled from '../../../components/ContentHeader';
import HoverableCard from '../../../components/HoverableCard';
import PaginationStyled from '../../../components/Pagination';
import { CHART_DESCRIPTIONS } from '../chartDescriptions';

interface Props {
  className?: string;
}

const CircularsPage = ({ className = '' }: Props) => (
  <div className={className}>
    <div className="content">
      <ContentHeaderStyled
        className="breadcrumbs"
        title="Circulars"
        breadcrumbs={[
          { label: 'Data Visualization', url: '/data-visualization' },
          { label: 'Circulars Chart' },
        ]}
      />

      <div className="cards">
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/circulars/donut']}
          title="Donut Chart"
          url="donut"
          image="/images/data-viz-circulars/donut.png"
          tags={['proportion']}
        />
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/circulars/polar']}
          title="Polar Area Chart"
          url="polar"
          image="/images/data-viz-circulars/polar-area.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/circulars/radar']}
          title="Radar Chart"
          url="radar"
          image="/images/data-viz-circulars/radar.png"
          tags={['comparison']}
        />
      </div>

      <PaginationStyled
        previousLink="/data-visualization/tables"
        previous="Tables"
        nextLink="/data-visualization/diagrams"
        next="Diagrams"
        className="footer-pagination"
      />
    </div>
  </div>
);

const StyledCircularsPage = styled(CircularsPage)`
  > .sidebar {
    overflow-x: hidden;
    height: calc(100vh - 4rem);
  }

  > .content {
    overflow-x: hidden;
    margin: 0 auto;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > .breadcrumbs {
      margin-bottom: 24px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: 40px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 80px;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    > .footer-pagination {
      display: none;
      margin-top: auto;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: block;
      }
    }
  }
`;

export default StyledCircularsPage;
